import { render, staticRenderFns } from "./AssessmentForm.vue?vue&type=template&id=15db6c97&scoped=true"
import script from "./AssessmentForm.vue?vue&type=script&lang=ts"
export * from "./AssessmentForm.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentForm.vue?vue&type=style&index=0&id=15db6c97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15db6c97",
  null
  
)

export default component.exports